export default {
  title: 'Estratti conto mensili',
  list: {
    empty_list: {
      title: 'Nessun estratto conto mensile.',
    },
    fields: {
      month: 'Mese',
      stripe_service_invoice_url: 'Fattura Stripe',
      paypal_service_invoice_url: 'Fattura PayPal',
    },
    button: {
      title: 'Esporta',
    },
  },
  export_modal: {
    title: 'Esporta',
    start_date: {
      title: 'Data inizio',
      placeholder: 'data',
    },
    end_date: {
      title: 'Data fine',
      placeholder: 'data',
    },
    button: {
      export: 'Esporta',
      close: 'Chiudi',
    },
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
